import { Box, Button, styled } from "@mui/material"

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "0px",
  padding: 0,
  margin: theme.spacing(2),
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "0px 0px 16px 0px #0000001A"
  }
}))

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "56px",
  minWidth: "56px"
}))
